import {
    CardActionArea,
    CardHeader,
    Divider,
    Box,
    CardContent,
    Card,
    Typography,
    Tooltip,
    IconButton,
    Grid,
  } from "@mui/material";
  import { CircleSVG } from "./Svg";
  import { useAppSelector } from "../../store/store";
  import { makeStyles } from "@material-ui/core/styles";
  import React, { useEffect, useState, memo } from "react";
  import { whiteClr } from "../../helper/service";
  import { nanoid } from "nanoid";
  import { LabelIcons } from "../newDashboard/Svg/labelIcons"
  
  const useStyles = makeStyles((theme: any) => ({
    customTooltip: {
      backgroundColor: "#577EC6",
      fontSize: "14px",
    },
  }));

  export const colorIndexData: any = {
    5: "#000000",
    4: "#871014",
    3: "#FFEF5C",
    2: "#FFEF5C",
    1: "#98E565",
    0: "#FFFFFF",
  };
  
  export function CustomTooltip(props: any) {
    const classes = useStyles();
  
    return <Tooltip classes={{ tooltip: classes.customTooltip }} {...props} />;
  }
  
  function FloorCardEmap(props: any) {
    const { themeMode } = useAppSelector((state) => state.themeSlice);
    const {
      allData,
      configureListNew,
      deviceList,
      goToSummaryPage,
      locationsList,
    } = props;

    const checkTextColor = (hexcolor: any) => {
      let color = hexcolor?.substring(1);
      let r = parseInt(color?.substr(0, 2), 16);
      let g = parseInt(color?.substr(2, 2), 16);
      let b = parseInt(color?.substr(4, 2), 16);
      let yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq > 200 || hexcolor === "#fff" || hexcolor === "#98E565"
        ? "#000"
        : "#fff";
    };
  
    const getDeviceBallTooltip = (deviceId: any) => {
      const getDeviceData = configureListNew?.find((l: any) => l.sk === deviceId);
  
      const deviceLocationName = getDeviceData?.location_name || "";
      const devicePk = getDeviceData?.pk;
  
      const deviceName = deviceList?.data?.find(
        (item: any) => item.id === devicePk?.substring(2)
      )?.attributes?.name;
  
      // return `${deviceName} [ ${deviceLocationName} ]`;
      return `${deviceName}`;
    };
  
    const getDeviceLocation = (deviceId: any, deviceIdx: number) => {
      const getDeviceData = configureListNew?.find((l: any) => l.sk === deviceId);
  
      const deviceLocationName = getDeviceData?.location_name || "";
  
      return `${deviceLocationName}`;
    };
  
    //Get Floor Name from roomid
    const getFloorNameOfUnitRoom = (roomId: any) => {
      //Same room exist under floor as well as unit
      const getAllRoomFromLocationList = locationsList?.filter(
        (l: any) => l?.key === roomId
      );
      const getAllParentKeysOfRoom = getAllRoomFromLocationList.map(
        (l: any) => l?.parentKey
      );
  
      let floorName = "";
      getAllParentKeysOfRoom.every((parentId: any) => {
        const findFloor = locationsList?.find((l: any) => l?.key === parentId);
        if (!findFloor?.is_unit) {
          floorName = `${findFloor?.prefix}: ${findFloor?.name}`;
          return false; // Returning false will break out of the loop
        }
        return true;
      });
      return floorName;
    };
  
    const getRoomName = (item: any) => {
      const maxLength = 12;
      if (item?.name?.length > maxLength) {
        // return `${item?.prefix}: ${item?.name.substring(0, maxLength)}..`;
        return (
          <Box className="alignItms">
            <LabelIcons
              type={item?.type}
              bgcolor={
                item?.colorOrder == "-Infinity" || item?.colorOrder === undefined
                  ? "#000000"
                  : checkTextColor(colorIndexData?.[item?.colorOrder])
              }
            />
            {`${item?.name.substring(0, maxLength)}..`}
          </Box>
        );
      } else {
        // return `${item?.prefix}: ${item?.name}`;
        return (
          <Box className="alignItms">
            <LabelIcons
              type={item?.type}
              bgcolor={
                item?.colorOrder == "-Infinity" || item?.colorOrder === undefined
                  ? "#000000"
                  : checkTextColor(colorIndexData?.[item?.colorOrder])
              }
            />
            {`${item?.name}`}
          </Box>
        );
      }
    };
  
    return (
      <>
        <Grid sx={{ paddingTop: "10px", p: 2 }} container spacing={2}>
          <Grid
            item
            key={nanoid()}
            xs={12}
            sx={{
              padding: "10px",
              paddingTop: "10px !important",
              boxShadow: "2px 2px 4px 2px #ddd",
            }}
          >
            <Grid container gap={2} className="box-wrapper">
              {allData?.roomData?.length > 0 ?
                allData?.roomData?.map((item: any, index: number) => {
                  return (
                    <Grid item xs={12} sm={5} md={5} sx={{ p: 2, opacity: item?.deviceCount > 0 ? "0.8" : "1", }}>
                      <Card sx={{
                        minHeight: "140px",
                        color: (item?.colorOrder == "-Infinity" || item?.colorOrder === undefined)
                          ? "#000000" : checkTextColor(colorIndexData?.[item?.colorOrder]),
                        backgroundColor: (item?.colorOrder == "-Infinity" || item?.colorOrder === undefined)
                          ? "#FFFFFF"
                          : colorIndexData?.[item?.colorOrder],
                      }}
                        key={index}
                        onClick={item?.deviceCount == "0" ? undefined : (e: any) => { goToSummaryPage("loc",item?.key ); }}>
                        <CardActionArea>
                          <CardHeader
                            sx={{ padding: "3px", paddingLeft: "10px" }}
                            title={getRoomName(item)}
                            subheader={
                              <>
                                {`Number of devices: ${item.deviceCount}`}
                                {allData?.is_unit ? <br /> : ""}
                                {allData?.is_unit
                                  ? getFloorNameOfUnitRoom(item?.key)
                                  : ""}
                              </>
                            }
                            subheaderTypographyProps={{
                              sx: {
                                color: themeMode === "dark" ? whiteClr : "",
                              },
                            }}
                            titleTypographyProps={{ variant: "h6" }} // Add this line to set the title font size
                          />
                          <Divider
                            sx={{
                              backgroundColor:
                                (item?.deviceCount > 0 &&
                                  (item?.colorOrder == "-Infinity" ||
                                    item?.colorOrder === undefined))
                                  ? "#000000"
                                  : checkTextColor(
                                    colorIndexData?.[item?.colorOrder]
                                  ),
                            }}
                          />
                          <CardContent
                            sx={{
                              padding: "0px",
                              height: "55px",
                              overflow:
                                item?.device_all_data?.length > 3
                                  ? "auto"
                                  : "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                padding: 1,
                                display: "flex",
                                gap: 1,
                                flexWrap: "wrap",
                                justifyContent: "flex-start",
                              }}
                            >
                              <>
                                <Box
                                  sx={{
                                    padding: 1,
                                    display: "flex",
                                    gap: 1,
                                    flexWrap: "wrap",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {item?.device_keys?.length > 0 &&
                                    item?.device_all_data?.length > 0 &&
                                    item?.device_all_data?.map(
                                      (childObj: any, childIdx: number) => (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "5px",
                                          }}
                                        >
                                          {/* <Typography
                                              sx={{
                                                ":hover": {
                                                  textDecoration: "underline",
                                                },
                                              }}
                                            >
                                              ({++childIdx}){" "}
                                              {getDeviceLocation(childObj?.key)}
                                            </Typography> */}
                                          <Typography>
                                            <CustomTooltip
                                              // title={getDeviceBallTooltip(
                                              //   childObj?.key
                                              // )}
                                              title={
                                                <Box>
                                                  {`Go to summary`}
                                                  <br />
                                                  <span style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                  }}>
                                                    <LabelIcons bgcolor={"#FFFFFF"} type={'device'} />
                                                    {getDeviceLocation(
                                                      childObj?.key,
                                                      childIdx
                                                    )}
                                                  </span>
                                                </Box>
                                              }
                                            >
                                              <IconButton
                                                sx={{ paddingTop: "0px" }}
                                              >
                                                <CircleSVG
                                                  key={index}
                                                  getnumber={""}
                                                  bgcolor={
                                                    (childObj?.colorOrder ==
                                                      "-Infinity" ||
                                                      childObj?.colorOrder ===
                                                      undefined)
                                                      ? "#FFFFFF"
                                                      : colorIndexData?.[
                                                      childObj?.colorOrder
                                                      ]
                                                  }
                                                  roomWrostColor={
                                                    item?.colorOrder
                                                  }
                                                  forType={"mapfloor"}
                                                  fontColor={""}
                                                  themeMode={themeMode}
                                                  size={20}
                                                />
                                              </IconButton>
                                            </CustomTooltip>
                                          </Typography>
                                        </Box>
                                      )
                                    )}
                                  {item?.device_keys?.length === 0 && (
                                    <Typography>No device found</Typography>
                                  )}
                                </Box>
                              </>
                            </Box>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Grid>
                  )
                }) : <Typography sx={{ color: "#000", fontSize: "15pt" }}>
                  No room found
                </Typography>}
            </Grid>
  
          
          </Grid>
        </Grid>
      </>
    );
  }
  export default memo(FloorCardEmap);